import React from 'react';

interface EditButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  saveDisabled?: boolean;
  saveText?: string;
  showKeyboardShortcuts?: boolean;
}

const EditButtons: React.FC<EditButtonsProps> = ({
  onSave,
  onCancel,
  isLoading,
  saveDisabled = false,
  saveText = 'Save',
  showKeyboardShortcuts = false,
}) => (
  <div className="flex items-center justify-between pt-2">
    <div className="flex gap-2">
      <button
        onClick={onSave}
        disabled={isLoading || saveDisabled}
        className="px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? 'Saving...' : saveText}
      </button>
      <button
        onClick={onCancel}
        disabled={isLoading}
        className="px-3 py-1 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 text-sm rounded-md hover:bg-gray-400 dark:hover:bg-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Cancel
      </button>
    </div>
    {showKeyboardShortcuts && (
      <div className="text-xs text-gray-500 dark:text-gray-400">
        Press Cmd/Ctrl+Enter to save, Escape to cancel
      </div>
    )}
  </div>
);

export default EditButtons;
